<div class="sidenav-content">
    <div class="bcontainer2">
      <div class="main-content"> 

        <div class="spacer2"></div>

        <div class="containter" id="labcontainer">

        <div style="float: right;">
            <mat-form-field>
            <mat-label>Select a user</mat-label>
            <mat-select (selectionChange)="onUserChange($event)">
                @for (user of users?.data?.profiles; track user.userkey) {
                <mat-option [value]="user.userkey">{{ user.name }}</mat-option>
                }
            </mat-select>
            </mat-form-field>
        </div> 

    <div class="mfhd">
        <i
          class="fa fa-angle-left"
          aria-hidden="true"
          style="padding-right: 5px"
        ></i
        >XD Chat
        <div
          class="page-description"
          style="
            color: #9c9b9b;
            font-size: 14px;
            margin-top: 8px;
            margin-bottom: 16px;
          "
        >
          XD Chat keeps your conversations meaningful with smart Remember and Memories features.
        </div>
      </div>
            
            <div class="chat-container">

                <div class="nodata" *ngIf="!(users?.data?.profiles?.length)">
                  There are no users for the selected workspace.
                </div>

                <div class="chat-messages" *ngIf="statement" id="chatMessages">
                    <div class="message receiver">{{statement}}</div>
                    <div class="message sender">
                        <span *ngIf="loading"><img src="assets/images/loader.svg" style="height: 20px;" class="loader"/></span>
                        <span *ngIf="!loading">{{stxt}}</span></div>
                </div>

                <div class="chat-input">
                    <input type="text" id="chatInput" matInput [readonly]="!userKey"
                      class="filter-input" (keydown.enter)="sendMessage()"
                      [formControl]="statementControl" placeholder="Type a message...">
                    <button mat-raised-button color="primary" class="clr-white" (click)="sendMessage()" [disabled]="statementControl.invalid || userKey == ''"><i class="fa fa-paper-plane"></i></button>
                    <!-- <div class="spacer-1"></div>
                    <div>
                    <mat-button-toggle-group style="margin: auto;">
                      <mat-button-toggle value="bold">Memories</mat-button-toggle>
                      <mat-button-toggle value="italic">Remember</mat-button-toggle>
                    </mat-button-toggle-group>
                    </div> -->
                </div>


            </div> 

        </div>
      
        </div>
    </div>
</div>